import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite"
import { htmlSpace } from "reusable/utils/utils"
import variables from "variables/variables"
import { themeConfig } from '@gap/shared/theme'

export default observer(function AuthSignupTerms({ isRegisterAction }: { isRegisterAction: boolean }) {
   const licenceAgreement = 'https://www.thegaphq.com/licence-agreement'
   const acceptableUsePolicy = 'https://www.thegaphq.com/acceptable-use-policy'

   const policyLink = isRegisterAction ? acceptableUsePolicy : licenceAgreement

   return (
      <Typography variant='body2' sx={{ color: themeConfig.grey[600], mb: -1 }}>
         By creating an account, you agree to {variables.gapName}'s{htmlSpace}
         <a href={policyLink} style={{ textDecoration: 'underline' }} data-testid="licence-agreement" target="_blank" rel="noreferrer">
            {isRegisterAction && 'Acceptable Use Policy'}
            {!isRegisterAction && 'Terms of Service'}
         </a>
         {' and '}
         <a href="https://www.thegaphq.com/privacy" style={{ textDecoration: 'underline' }} data-testid="privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
         </a>
      </Typography>
   )
})
